import { tv } from "@/utils/tv.config";
import { VariantProps } from "tailwind-variants";

export const tabsClasses = tv({
  base: ["Tabs__Root"],
  variants: {
    orientation: {},
    centered: {
      true: "justify-center",
    },
    fullWidth: {
      true: "w-full",
    },
  },
});

export type TabsVariants = VariantProps<typeof tabsClasses>;
